import React from 'react'
import {Link} from 'react-router-dom';

const FeaturedMenuItem = ({className, handleMenuClick, title, id}) => {
  return (
    <li className={className}>
      <Link to="/" data-id={id} onClick={handleMenuClick}>{title}</Link>
    </li>
  )
};

export default FeaturedMenuItem
